export default __webpack_public_path__ + "static/media/WM0480.34I-43867_-26183_0.d5f206a0.jpg";